import {Col, Flex, Image, Layout, Row} from "antd";
import {SwitchLangButton} from "@/component/common/button/SwitchLangButton.tsx";
import {useTranslation} from "react-i18next";

import LoginImage1 from "@/assets/images/loginPageImage1.png";

const AuthLayout = ({children}: { children: any }) => {
    const {t} = useTranslation();

    return <>
        <Layout className="w-full h-full overflow-hidden !bg-gradient-to-b from-[#F1F6FF] to-[#F1F7FF]">
            <div className={'absolute top-5 right-5 z-10'}>
                <SwitchLangButton/>
            </div>
            <Row className={'h-screen'}>
                <Col span={12} className={'text-center'}>
                    <div className={'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[672px]'}>
                        <p className={'text-[42px] text-[#0A3166] font-bold'}>
                            {t('title.licenseManagementLogo')}
                        </p>
                        <Flex justify={'center'}>
                            <p className={'text-start text-[14px] text-[#333333] mt-14'}>
                                {t('message.authPageDescription1')} <br/>
                                {t('message.authPageDescription2')}
                            </p>
                        </Flex>
                        <Image
                            src={LoginImage1}
                            preview={false}
                            className={"mt-20"}
                        />
                    </div>
                </Col>
                <Col span={12}>
                    {children}
                </Col>
            </Row>
        </Layout>
    </>
}

export default AuthLayout;